import { Injectable } from '@angular/core';
import { AngularFireAuth } from 'angularfire2/auth';
import { AngularFireDatabase, FirebaseObjectObservable } from 'angularfire2/database';
import { Observable } from 'rxjs/Observable';

import * as firebase from 'firebase/app';

@Injectable()
export class AuthService {

  constructor(
    private afAuth: AngularFireAuth,
    private db:       AngularFireDatabase
  ) {}

  authenticated(): Observable<boolean> {
    return Observable.create(observer => {
      this.afAuth.authState.subscribe(
        data => {
          if (data) {
            this.getUserInfo(data.uid).subscribe(
              userData => observer.next( this.checkIfSuperUser(userData) )
            );
          } else {
            observer.next(false);
          }
        }
      );
    });
  }

  private getUserInfo(userId: string): FirebaseObjectObservable<any> {
    return this.db.object('/users/' + userId);
  }

  private checkIfSuperUser(data): boolean {
    if (data.superUser) {
      return true;
    } else {
      return false;
    }
  }

  login(email: string, password: string): Observable<any> {
    return Observable.create(observer => {
      this.afAuth.auth.signInWithEmailAndPassword(email, password)
        .then(user => {
          observer.next(user);
        })
        .catch(error => observer.error(error));
    });
  }

  resetPassword(email: string): firebase.Promise<any> {
    return this.afAuth.auth.sendPasswordResetEmail(email)
  }

  signOut(): void {
    this.afAuth.auth.signOut();
  }

}



// WEBPACK FOOTER //
// ./src/app/core/auth.service.ts